<template>
    <el-row id="taskPerform">
        <collectionBar :tags="tags" :subTitle="subTitle" :btnBack="true" @btnBackClick="handleBackClick" />
        <el-row>
            <el-row style="margin-top: 15px;">
                <el-col :span="24" style="text-align: right;">
                    <p style="font-size: 16px;color: #4A90E2;margin:0;line-height: 36px;">销售人员总数：{{sum}}人</p>
                </el-col>
            </el-row>
            <el-row >
                <el-tabs refs="tabs" v-model="activeName" @tab-click="tabHandleClick" style="height: 100%"
                    class="eltabs">
                    <el-tab-pane v-if="tabShow.showInstitution" label="医疗机构" name="INSTITUTION"
                        style="overflow-y: auto;">
                        <el-table :data="tableData" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="territory_name" label="辖区">
                                <template slot-scope="scope">
                                    <span
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        {{scope.row.territory_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="last_name" label="销售人员">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.last_name">
                                        -
                                    </span>
                                    <span v-else>
                                        {{scope.row.last_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="ins_num" label="提交机构记录数">
                            </el-table-column>
                            <el-table-column prop="institution_timestamp" label="最后机构提交时间">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.institution_timestamp">
                                        -
                                    </span>
                                    <span v-else>
                                        {{ formatMoment(scope.row.institution_timestamp) }}
                                    </span>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="HCP" v-if="tabShow.showHcp" name="HCP" style="overflow-y: auto;">
                        <el-table :data="tableData" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="territory_name" label="辖区">
                                <template slot-scope="scope">
                                    <span
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        {{scope.row.territory_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="last_name" label="销售人员">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.last_name">
                                        -
                                    </span>
                                    <span v-else>
                                        {{scope.row.last_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="hcp_num" label="提交HCP记录数">
                            </el-table-column>
                            <el-table-column prop="hcp_timestamp" label="最后HCP提交时间">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.hcp_timestamp">
                                        -
                                    </span>
                                    <span v-else>
                                        {{ formatMoment(scope.row.hcp_timestamp) }}
                                    </span>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-tab-pane>

                    <el-tab-pane label="门店" v-if="tabShow.showRetailstore" name="RETAILSTORE" style="overflow-y: auto;">
                        <el-table :data="tableData" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="territory_name" label="辖区">
                                <template slot-scope="scope">
                                    <span
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        {{scope.row.territory_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="last_name" label="销售人员">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.last_name">
                                        -
                                    </span>
                                    <span v-else>
                                        {{scope.row.last_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="store_num" label="提交门店记录数">
                            </el-table-column>
                            <el-table-column prop="retailstore_timestamp" label="最后门店提交时间">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.retailstore_timestamp">
                                        -
                                    </span>
                                    <span v-else>
                                        {{ formatMoment(scope.row.retailstore_timestamp) }}
                                    </span>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="经销商" v-if="tabShow.showDistributor" name="DISTRIBUTOR"
                        style="overflow-y: auto;">
                        <el-table :data="tableData" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="territory_name" label="辖区">
                                <template slot-scope="scope">
                                    <span
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        {{scope.row.territory_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="last_name" label="销售人员">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.last_name">
                                        -
                                    </span>
                                    <span v-else>
                                        {{scope.row.last_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="dis_num" label="提交经销商记录数">
                            </el-table-column>
                            <el-table-column prop="distributor_timestamp" label="最后经销商提交时间">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.distributor_timestamp">
                                        -
                                    </span>
                                    <span v-else>
                                        {{ formatMoment(scope.row.distributor_timestamp) }}
                                    </span>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-tab-pane>

                    <el-tab-pane label="自定义表格" v-if="tabShow.showCustomtable" name="CUSTOMTABLE"
                        style="overflow-y: auto;">
                        <el-table :data="tableData" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="territory_name" label="辖区">
                                <template slot-scope="scope">
                                    <span
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        {{scope.row.territory_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="last_name" label="销售人员">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.last_name">
                                        -
                                    </span>
                                    <span v-else>
                                        {{scope.row.last_name}}
                                    </span>

                                </template>
                            </el-table-column>
                            <el-table-column prop="custom_num" label="提交自定义表格记录数">
                            </el-table-column>
                            <el-table-column prop="customtable_timestamp" label="最后自定义表格提交时间">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.customtable_timestamp">
                                        -
                                    </span>
                                    <span v-else>
                                        {{ formatMoment(scope.row.customtable_timestamp) }}
                                    </span>
                                </template>
                            </el-table-column>

                        </el-table>
                    </el-tab-pane>
                </el-tabs>
                <pagination :page="page" @changePage="changePageClick"></pagination>
            </el-row>
        </el-row>
    </el-row>
</template>

<script>
    import collectionBar from '../../../components/collectionBar'
    import pagination from '../../../components/pagination'
    import http from "../../../APIService/http";
    import moment from 'moment'
    export default {
        name: "taskPerform",
        data() {
            return {
                tags: ['数据采集任务', '任务执行'],
                activeName: "",
                tabShow: {
                    showInstitution: false,
                    showHcp: false,
                    showRetailstore: false,
                    showDistributor: false,
                    showCustomtable: false,
                },
                subTitle: '',
                tableData: [],
                collectProfile: [],
                task_id: '',
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                sum: 0,


            }
        },


        components: {
            collectionBar,
            pagination
        },
        created() {
            this.collectProfile = JSON.parse(localStorage.getItem('collectProfile'))
            console.log(this.collectProfile)
            this.task_id = this.collectProfile.task_id
            this.subTitle = this.collectProfile.task_name
            this.init()


            this.activeName = "";
            this.collectProfile.reference_obj.forEach(element => {
                if (element === "INSTITUTION") {
                    this.tabShow.showInstitution = true;
                    if (this.activeName === "") {
                        this.activeName = element;
                    }
                } else if (element === "HCP") {
                    this.tabShow.showHcp = true;
                    if (this.activeName === "") {
                        this.activeName = element;
                    }
                } else if (element === "RETAILSTORE") {
                    this.tabShow.showRetailstore = true;
                    if (this.activeName === "") {
                        this.activeName = element;
                    }
                } else if (element === "DISTRIBUTOR") {
                    this.tabShow.showDistributor = true;
                    if (this.activeName === "") {
                        this.activeName = element;
                    }
                } else if (element === "CUSTOMTABLE") {
                    this.tabShow.showCustomtable = true;
                    if (this.activeName === "") {
                        this.activeName = element;
                    }
                }

            });
        },
        methods: {
            formatMoment(date) {
                return moment(date).format("YYYY-MM-DD HH:mm:ss");
            },
            async init() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        task_id: this.task_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,

                    }
                    await http.post('/wapi/Collect/getTaskPerformList', data).then(res => {
                        if (res.success) {
                            console.log(res.data)
                            this.tableData = res.data.array

                            this.sum = res.data.count
                            this.page.total = res.data.count


                            loading.close()
                        }

                    })
                } catch (e) {
                    loading.close()
                }
            },
            changePageClick(page, size) {
                console.log(page + "---" + size);
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                console.log(page + "---" + this.page.size);
                this.init()
            },
            handleBackClick() {
                this.$router.push({ name: 'CollectionHome' })
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/collection/components/taskPerform.vue